import { createFileRoute } from "@tanstack/react-router";
import { PublicNav } from "@/components/site/PublicNav";
import { Footer } from "@/components/site/Footer";
import { AskShieldsChat } from "@/components/chat/AskShieldsChat";

export const Route = createFileRoute("/ask")({
  head: () => ({
    meta: [
      { title: "Ask Shields — AI answers about home services" },
      {
        name: "description",
        content:
          "Ask the Shields AI assistant anything about small home jobs, typical UK prices, and how booking verified local partners works.",
      },
      { property: "og:title", content: "Ask Shields — AI answers about home services" },
      {
        property: "og:description",
        content: "Instant answers on home services, prices and bookings from the Shields AI assistant.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
  }),
  component: AskPage,
});

function AskPage() {
  return (
    <div className="flex min-h-screen flex-col">
      <PublicNav />
      <main className="section-pad mx-auto flex w-full max-w-3xl flex-1 flex-col py-10">
        <h1 className="text-3xl font-bold sm:text-4xl">Ask Shields</h1>
        <p className="mt-2 text-muted-foreground">
          Questions about a home job, typical prices or how Shields works? Ask away — then
          open a booking request when you're ready for real bids.
        </p>
        <div className="mt-6 min-h-[34rem] flex-1">
          <AskShieldsChat />
        </div>
      </main>
      <Footer />
    </div>
  );
}
